<template>
  <section id="app">
    <router-view :key="key"></router-view>
    <float-icon padding="10 10 30 10" class="icons-warp" v-if="$route.meta.toBack">
      <div class="to-home"  @click="toBack">返回</div>
    </float-icon>
<!--    <van-floating-bubble-->
<!--        v-if="$route.meta.toBack"-->
<!--        axis="xy"-->
<!--        icon="revoke"-->
<!--        @click="toBack"-->
<!--    />-->
  </section>
</template>

<script>
import { storage } from "@/utils/util";
import FloatIcon from "./views/home/FloatIcon.vue";
import systemConfig from "./config/systemConfig";
export default {
  components: {
    FloatIcon
  },
  data() {
    return {
      loginType: storage.getStorage("loginType") || "",
    };
  },
  computed: {
    key() {
      return this.$route.name !== undefined
        ? this.$route.name + new Date()
        : this.$route + new Date();
    },
  },
  created() {
  },
  mounted() {
    document.documentElement.style.setProperty("--main-menu-top", "url('" + systemConfig.homeTopBg + "')");
    document.documentElement.style.setProperty("--loading-bg", "url('" + systemConfig.customerLoadingIcon + "')");
    // 主题变更
    if (window.location.host === "qywx.jinzhimc.cn") {
      // 金致
      document.documentElement.style.setProperty("--mine-page-bg", "url('./static/theme/jinzhi/mine_bg.png')");
    } else {
      // 欣成旺斯
      document.documentElement.style.setProperty("--mine-page-bg", "url('./static/theme/xcws/mine_bg.jpg')");
    }
  },
  methods: {
    //返回
    toBack() {
      window.history.go(-1);
    },
  },
};
</script>

<style>
/*主题样式*/
:root{
  /** 登录首页的top*/
  --main-menu-top: "";
  /**个人中心的bg*/
  --mine-page-bg: "";
  /*加载的大动画*/
  --loading-bg: "";
}
#app {
  height: 100%;
  width: 100%;
}
.to-home {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  background: #027fea;
  color: #fff;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// App.vue?30348ff4